import client from '@/api/client.js';
import store from "@/store";

export default {
    methods: {
        async getCheckListTemplatesFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getCheckListTemplatesFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "CheckListTemplate/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getCheckListTemplates() {
            var response = await client().get(store.state.apiRouteRoot + "CheckListTemplate")
            return response.data;
        },
        async getCheckListTemplate(templateId) {
            var response = await client().get(store.state.apiRouteRoot + "CheckListTemplate/" + templateId)
            return response.data;
        },
        async createCheckList(dto) {
            var response = await client().post(store.state.apiRouteRoot + "CheckListTemplate/", dto);
            return response.data;
        },
        async updateCheckListTemplate(dto) {
            var response = await client().patch(store.state.apiRouteRoot + `CheckListTemplate`, dto);
            return response.data;
        },


        async getCheckListEntry(entryId) {
            var response = await client().get(store.state.apiRouteRoot + "checklist/?entryId=" + entryId)
            return response.data;
        },
        async getCheckListForJob(jobId) {
            var response = await client().get(store.state.apiRouteRoot + "checklist/list-job-entries?parentJobId=" + jobId)
            return response.data;
        },
        async resetCheckListForJob(parentJobId) {
            var response = await client().delete(store.state.apiRouteRoot + "checklist/reset/" + parentJobId)
            return response.data;
        },
        async startCheckListForJob(jobId, templateId) {
            var response = await client().post(store.state.apiRouteRoot + "checklist/start?jobId=" + jobId + "&templateId=" + templateId)
            return response.data;
        },


        async addCheckListTemplateField(templateId) {
            var response = await client().post(store.state.apiRouteRoot + `checklist/templates/${templateId}/`);
            return response.data;
        },
        async updateCheckListField(entry) {
            var response = await client().patch(store.state.apiRouteRoot + `checklist/field/`, entry);
            return response.data;
        },


        async addCheckListActivation(templateId, activation) {
            var response = await client().post(store.state.apiRouteRoot + `checklist/templates/${templateId}/activations`, activation);
            return response.data;
        },
        async updateCheckListActivation(activation) {
            var response = await client().patch(store.state.apiRouteRoot + `checklist/activations`, activation);
            return response.data;
        },
        async deleteCheckListActivation(activationId) {
            var response = await client().delete(store.state.apiRouteRoot + `checklist/activations/${activationId}`);
            return response.data;
        },
    }
}
